import { render } from "./EspaceVideo.vue?vue&type=template&id=00fd1206&scoped=true"
const script = {}

import "./EspaceVideo.vue?vue&type=style&index=0&id=00fd1206&scoped=true&lang=css"

import exportComponent from "E:\\User\\Documents\\GitHub\\PortailMalecites\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00fd1206"]])

export default __exports__